import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './types.tsx';

const LazyNoPlanPermissionErrorPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-arj-no-plan-permission", jiraPriority: 'ondemand' */ './index'
		),
);

export const AsyncNoPlanPermissionErrorPage = (props: Props) => (
	<Placeholder name="arj-no-plan-permission" fallback={<Spinner />}>
		<LazyNoPlanPermissionErrorPage {...props} />
	</Placeholder>
);
